import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { CustomPrice } from '../../../../common/order/customPrice'
import classes from '../../../index.module.scss'
import { SelectOrEnterCode } from '../popupBuyPackage/common/SelectOrEnterCode'

export const PriceDiscount = ({ title, price, appendStyle, discount }) => {
  return (
    <div className={classes.upgradeAccRowContainer} style={{ ...appendStyle }}>
      <Element className={[classes.title, 'fw600'].join(' ')}>
        <Translate value={title} />
      </Element>
      <div className="flexColumn">
        <CustomPrice
          value={price}
          style={{
            color: '#2C73E8',
            fontSize: 14,
            fontWeight: 600,
            marginLeft: 5,
          }}
          className={classes.w300}
        />
      </div>
      <div style={{ paddingLeft: 2 }}>
        <SelectOrEnterCode price={price} discountOther={discount} />
      </div>
    </div>
  )
}
